/*=============================================== CardBasic ===============================================*/
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*==================== Imports ====================*/
import React from "react";
import styled from "styled-components";
import CardContainer from "./CardContainer";
import Variables from "./Variables";
import { H5, P } from "./Font";
import Mixins from "./Mixins";
import Icon from "./Icon";
import FajnyIcon from "./FajnyIcon";
/*==================== Component ====================*/
var CardBasic = function (_a) {
    var title = _a.title, children = _a.children, to = _a.to, _b = _a.orientation, orientation = _b === void 0 ? "portrait" : _b, icon = _a.icon, fajnyIcon = _a.fajnyIcon, props = __rest(_a, ["title", "children", "to", "orientation", "icon", "fajnyIcon"]);
    return (React.createElement(Container, __assign({ to: to ? to : undefined, "$orientation": orientation }, props),
        icon && React.createElement(Icon, { src: icon, size: 48, color: Variables.Colors.Primary500 }),
        fajnyIcon && React.createElement(FajnyIcon, { name: fajnyIcon, size: 48, color: Variables.Colors.Primary500 }),
        React.createElement(Content, { "$orientation": orientation },
            React.createElement(H5, null, title),
            children && React.createElement(P, null, children))));
};
export default CardBasic;
/*==================== Types ====================*/
var orientation = {
    portrait: "portrait",
    landscape: "landscape",
};
/*==================== Styles ====================*/
var Container = styled(CardContainer)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: ", ";\n    ", ";\n    text-align: ", ";\n"], ["\n    padding: ", ";\n    ", ";\n    text-align: ", ";\n"])), Variables.Spacers.S, function (_a) {
    var $orientation = _a.$orientation;
    return Mixins.Flexbox({
        $align: "center",
        $justify: "center",
        $gap: "m",
        $direction: $orientation === "portrait" ? "column" : "row",
    });
}, function (_a) {
    var $orientation = _a.$orientation;
    return $orientation === "portrait" && "center";
});
var Content = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", ";\n    flex-grow: ", ";\n"], ["\n    ", ";\n    flex-grow: ", ";\n"])), Mixins.Grid({
    $gap: "xxs",
}), function (_a) {
    var $orientation = _a.$orientation;
    return $orientation === "landscape" && 1;
});
var templateObject_1, templateObject_2;
